import { StyleProvider } from "@ant-design/cssinjs";
import { App as AntApp, theme as antdTheme, ConfigProvider } from "antd";
import type { ReactNode } from "react";
import { useTheme } from "@/modules/attendance-app/context/ThemeContext";

interface AntdProviderProps {
	children: ReactNode;
}

export function AntdProvider({ children }: AntdProviderProps) {
	const { isDark } = useTheme();

	return (
		<StyleProvider layer>
			<ConfigProvider
				theme={{
					algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
					token: {
						colorPrimary: "#1890ff",
						borderRadius: 6,
						...(isDark
							? {
									colorBgContainer: "#14142a",
									colorBgElevated: "#1e1e35",
									colorBorder: "#2a2a42",
									colorText: "#e2e8f0",
									colorTextPlaceholder: "#8a99ad",
								}
							: {}),
					},
					components: {
						Layout: {
							siderBg: "#001529",
						},
						Select: isDark
							? {
									colorBgContainer: "#14142a",
									colorBgElevated: "#1e1e35",
									colorBorder: "#2a2a42",
									colorText: "#e2e8f0",
									colorTextPlaceholder: "#8a99ad",
									selectorBg: "#14142a",
								}
							: {},
						DatePicker: isDark
							? {
									colorBgContainer: "#14142a",
									colorBgElevated: "#1e1e35",
									colorBorder: "#2a2a42",
									colorText: "#e2e8f0",
									colorTextPlaceholder: "#8a99ad",
								}
							: {},
					},
				}}
			>
				<AntApp>{children}</AntApp>
			</ConfigProvider>
		</StyleProvider>
	);
}
